<template>
	<mobile v-if="mobile" :id="id"></mobile>
	<pc v-else :id="id"></pc>
</template>

<script>
	import pc from './project_detail_pc.vue'
	import mobile from './project_detail_m.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'project_detail',
		
		components: {
			pc,
			mobile
		},
		
		props: {
			id: String
		},
		
		computed: {
			...mapState(['mobile'])
		}
	};
</script>

<style lang="stylus" scoped>
</style>